<template>
    <div class="first-information-form2">
         <slot name="how-register-modal"></slot>
        <div class="edit-info" v-if="getEditionMode">
            <b-button
                :variant="getIsDarkTheme ? 'outline-light' : 'outline-dark'"
                size="sm"
                @click="changeStatusDisabled(false)"
            >
                Editar informações
            </b-button>
        </div>

        <b-form @submit.stop.prevent="onSubmit" novalidate>
            <b-form-group label="Possui CNPJ?" class="required" label-for="hasCnpj">
                <b-form-radio-group
                    id="hasCnpj"
                    name="hasCnpj"
                    v-model="$v.form.hasCnpj.selected.$model"
                    :options="form.hasCnpj.options"
                    :state="validateState('hasCnpj')"
                    stacked
                    :disabled="getIsDisabled"
                ></b-form-radio-group>

                <b-form-invalid-feedback :state="validateState('hasCnpj')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group v-if="form.hasCnpj.selected">
                <label for="cnpj" class="required">
                    Números do CNPJ
                </label>

                <b-form-input
                    id="cnpj"
                    name="cnpj"
                    v-model="$v.form.cnpj.$model"
                    v-mask="'##.###.###/####-##'"
                    type="tel"
                    placeholder="Digite seu CNPJ"
                    :state="validateState('cnpj')"
                    :disabled="getIsDisabled"
                    v-if="!isPlatform || (isPlatform && getAuthorizationData && getAuthorizationData['cnpj'].value)"
                ></b-form-input>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['cnpj'].value"
                />

                <b-form-invalid-feedback :state="validateState('cnpj')">
                    <div v-if="!$v.form.cnpj.required">
                        Campo obrigatório
                    </div>

                    <div v-if="!$v.form.cnpj.minLength">
                        Deve conter 18 caracteres
                    </div>
                </b-form-invalid-feedback>

                <LockPP
                    :statusLock="form.cnpjLock"
                    :lockMsg="'Privado'"
                    :unlockMsg="'Público'"
                    @click="form.cnpjLock = Number(!form.cnpjLock)"
                    v-if="showLock"
                />
            </b-form-group>

            <b-form-group label="Nome da iniciativa" label-for="initiativeName" class="required">
                <b-form-input
                    id="initiativeName"
                    name="initiativeName"
                    v-model="$v.form.initiativeName.$model"
                    type="text"
                    placeholder="Digite o nome"
                    :state="validateState('initiativeName')"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['nome_organizacao'].value)
                    "
                ></b-form-input>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['nome_organizacao'].value"
                />

                <b-form-invalid-feedback :state="validateState('initiativeName')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
                label="Descreva sua iniciativa em até 500 caracteres"
                label-for="aboutInitiative"
                class="required"
            >
                <b-form-textarea
                    id="aboutInitiative"
                    name="aboutInitiative"
                    v-model="$v.form.aboutInitiative.$model"
                    placeholder="Seja sucinto, mas capriche! É essa descrição que aparecerá aos que acessarem seu perfil."
                    rows="6"
                    :state="validateState('aboutInitiative')"
                    :disabled="getIsDisabled"
                ></b-form-textarea>

                <b-form-invalid-feedback :state="validateState('aboutInitiative')">
                    <div v-if="!$v.form.aboutInitiative.required">Campo obrigatório</div>
                    <div v-if="!$v.form.aboutInitiative.maxCharacter">Quantidade máxima de caracteres: 500</div>
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Logo da sua organização">
                <FormFilePP
                    :ref="'fileRef'"
                    :text1="textFile1"
                    :text2="textFile2"
                    :disabled="getIsDisabled"
                    :singleFile="true"
                    :previewImg="true"
                    :singleFileData="getSingleFileData()"
                    :urlSingleFileData="form.urlSingleFileData"
                    :showSingleFile="!receiveData"
                    @fileSelected="onClickFileField"
                    @removeSingleFile="removeSingleFile"
                    v-if="form.showFile"
                />
            </b-form-group>

            <hr class="line" />

            <div class="footer-buttons">
                <slot name="platform-bottom-buttons"></slot>

                <b-button
                    :variant="'secondary'"
                    class="radius-6"
                    @click="$router.push({ name: 'FirstInformationForm1' })"
                    v-if="!showFooterButtons"
                    >Voltar</b-button
                >
                <b-button type="submit" :variant="'primary'" class="radius-6 submit" v-if="!showFooterButtons"
                    >Próximo</b-button
                >

                <div class="display-initial" v-else>
                    <b-button :variant="'secondary'" @click="changeRegisterForm('FirstInformationForm1')"
                        >Voltar</b-button
                    >

                    <b-button
                        :variant="'primary'"
                        :disabled="!getIsDisabled"
                        @click="changeRegisterForm('AboutInitiativeForm1')"
                        v-if="getAbbleNextPage"
                    >
                        Próximo
                    </b-button>
                </div>

                <b-button variant="success" @click="saveData(progress)" v-if="getEditionMode && !getIsDisabled">
                    Salvar
                </b-button>
            </div>
        </b-form>

        <b-modal
            ref="warning-modal-ref"
            :hide-header="true"
            :hide-footer="true"
            body-class="warning-modal"
            :modal-class="getIsDarkTheme ? 'dark-theme' : ''"
            :no-close-on-backdrop="true"
        >
            <div class="content">
                <DangerMsgModal :msg="message" />
            </div>

            <div class="footer-buttons">
                <b-button variant="danger" @click="hideModal('warning-modal-ref')">Fechar</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { required, minLength } from 'vuelidate/lib/validators'
import DangerMsgModal from '@/ui/modal/danger-msg-modal/DangerMsgModal'
import LockPP from '@/ui/lock-pp/LockPP'
import FormFilePP from '@/ui/form-file-pp/FormFilePP'
import { RegisterFirstInformationApi } from '../../api/register-first-information/'
import { AuthorizationApi } from '../../api/admin/authorization-api'
import NoAuthorizationMsgPP from '@/ui/no-authorization-msg-pp/NoAuthorizationMsgPP'

const authorizationApi = new AuthorizationApi()
const registerFirstInformationApi = new RegisterFirstInformationApi()

export default {
    components: { DangerMsgModal, NoAuthorizationMsgPP, LockPP, FormFilePP },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        editionMode: {
            type: Boolean,
            default: false
        },
        isPlatform: {
            type: Boolean,
            default: false
        },
        showFooterButtons: {
            type: Boolean,
            default: false
        },
        receiveData: {
            default: null
        },
        userIdLogged: {
            default: null
        },
        allowAuthorization: {
            type: Boolean,
            default: false
        },
        abbleNextPage: {
            type: Boolean,
            default: false
        },
        showLock: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            progress: 5.54,
            message: null,
            textFile1: 'Tamanho de upload de imagem para 2 Mb',
            textFile2: 'Arquivos suportados: .png, .jpg',
            usuario: null,
            isDisabled: null,
            firstInfoData: null,
            authorizationData: null,
            imageSelected: false,
            form: {
                cnpjLock: 1,
                hasCnpj: {
                    selected: null,
                    options: [
                        { text: 'Sim', value: 1 },
                        { text: 'Não', value: 0 }
                    ]
                },
                cnpj: null,
                initiativeName: null,
                aboutInitiative: null,
                urlFile: null,
                urlFileTemp: null,
                singleFileData: null,
                urlSingleFileData: null,
                showFile: false
            }
        }
    },
    validations: {
        form: {
            initiativeName: { required },
            hasCnpj: { selected: { required } },
            cnpj: {
                required() {
                    return !(this.form.hasCnpj.selected === 1 && this.form.cnpj === null)
                },
                minLength: minLength(18)
            },
            aboutInitiative: {
                required,
                maxCharacter() {
                    return this.form.aboutInitiative !== null && this.form.aboutInitiative.length <= 500
                }
            }
        }
    },
    methods: {
        ...mapActions(['setIsLoading', 'setCurrentFormPlatform', 'setProgress']),
        fetchRead() {
            const data = this.receiveData

            this.form.hasCnpj.selected = data.possui_cnpj
            this.form.cnpj = data.cnpj
            this.form.initiativeName = data.nome_organizacao
            this.form.aboutInitiative = data.descricao_organizacao
            this.form.cnpjLock = data.view_cnpj

            if (this.allowAuthorization) {
                this.setIsLoading(true)

                authorizationApi
                    .getFirstInformations(this.userIdLogged)
                    .then(response => {
                        this.authorizationData = response.data.data
                    })
                    .catch(error => {
                        this.message = error.response.data.message
                        this.$refs.warningModal.showModal()
                    })
                    .finally(() => {
                        this.setIsLoading(false)
                    })
            }

            if (Object.keys(data).includes('url_logo')) {
                if (data.url_logo) {
                    this.loadingFiles(data)
                }
            }

            this.form.showFile = true
        },
        fetch() {
            if (Object.keys(localStorage).includes('firstInfo')) {
                this.firstInfoData = JSON.parse(localStorage.getItem('firstInfo'))

                this.form.hasCnpj.selected = this.firstInfoData.possui_cnpj
                this.form.cnpj = this.firstInfoData.cnpj
                this.form.initiativeName = this.firstInfoData.nome_organizacao
                this.form.aboutInitiative = this.firstInfoData.descricao_organizacao
                this.form.cnpjLock = [undefined, null].includes(this.firstInfoData.view_cnpj)
                    ? 1
                    : this.firstInfoData.view_cnpj

                if (this.firstInfoData.urlLogoTemp) {
                    this.loadingFilesTemp(this.firstInfoData)
                }

                this.form.showFile = true

                this.setProgress(this.firstInfoData.percentual)
            } else {
                if (Object.keys(localStorage).includes('usuario')) {
                    this.setIsLoading(true)
                    registerFirstInformationApi
                        .listFirst()
                        .then(res => {
                            this.form.id = res.data.id
                            this.form.hasCnpj.selected = res.data.possui_cnpj
                            this.form.cnpj = res.data.cnpj
                            this.form.initiativeName = res.data.nome_organizacao
                            this.form.aboutInitiative = res.data.descricao_organizacao
                            this.form.isProvider = res.data.prestador_servico
                            this.form.origin = res.data.id_natureza_inicitiva
                            this.form.initiative = res.data.id_iniciativa
                            this.form.legalFormat = res.data.id_formato_juridico
                            this.form.ods = res.data.ods
                            this.form.areas = res.data.principal_area_atuacao
                            this.form.state = res.data.estado_desenvolve_acao
                            this.form.city = res.data.cidade_desenvolve_acao
                            this.form.cnpjLock = res.data.view_cnpj === null ? 1 : res.data.view_cnpj
                            this.id_organizacao = res.data.id_organizacao

                            if (Object.keys(res.data).includes('url_logo')) {
                                if (res.data.url_logo) {
                                    this.loadingFiles(res.data)
                                }
                            }

                            this.form.showFile = true

                            this.setProgress(res.data.percentual)
                        })
                        .catch(error => {
                            this.message = error.response.data.message
                            this.showModal('warning-modal-ref')
                        })
                        .finally(() => {
                            this.setIsLoading(false)
                        })
                }
            }
        },
        saveTempData(newProgress) {
            if (this.firstInfoData !== null) {
                this.firstInfoData = {
                    ...this.firstInfoData,
                    possui_cnpj: this.form.hasCnpj.selected,
                    cnpj: this.form.cnpj,
                    view_cnpj: this.form.cnpjLock,
                    percentual: this.getProgress < newProgress ? newProgress : this.getProgress,
                    nome_organizacao: this.form.initiativeName,
                    descricao_organizacao: this.form.aboutInitiative
                }

                if (this.$refs['fileRef'] && this.$refs['fileRef'].image) {
                    this.firstInfoData.url_logo = this.$refs['fileRef'] ? this.$refs['fileRef'].image : null
                    this.firstInfoData.urlLogoTemp = this.$refs['fileRef'] ? this.$refs['fileRef'].urlSingleFile : null
                    // this.firstInfoData.url_logo = this.form.urlFile
                } else {
                    this.firstInfoData.url_logo = this.form.urlFile
                    // this.firstInfoData.urlLogoTemp = this.form.urlFileTemp
                }

                this.setProgress(this.firstInfoData.percentual)
                localStorage.setItem('firstInfo', JSON.stringify(this.firstInfoData))
                this.nextPage()
            }
        },
        saveData(newProgress) {
            this.$v.form.$touch()
            if (this.$v.form.$anyError) {
                return
            }

            this.setIsLoading(true)

            const data = {
                id: this.form.id,
                prestador_servico: this.form.isProvider,
                id_natureza_inicitiva: this.form.origin,
                id_iniciativa: this.form.initiative,
                id_formato_juridico: this.form.legalFormat,
                ods: this.form.ods,
                view_cnpj: this.form.cnpjLock,
                principal_area_atuacao: this.form.areas,
                estado_desenvolve_acao: this.form.state,
                cidade_desenvolve_acao: this.form.city,
                id_organizacao: this.id_organizacao,
                possui_cnpj: this.form.hasCnpj.selected,
                cnpj: this.form.cnpj,
                nome_organizacao: this.form.initiativeName,
                percentual: this.getProgress < newProgress ? newProgress : this.getProgress,
                descricao_organizacao: this.form.aboutInitiative,
                url_logo: null
            }

            if (this.$refs['fileRef'] && this.$refs['fileRef'].image) {
                data.url_logo = this.$refs['fileRef'] ? this.$refs['fileRef'].image : null
            } else {
                data.url_logo = this.form.urlFile
            }

            registerFirstInformationApi
                .updateFirst(data)
                .then(res => {
                    this.setProgress(data.percentual)
                    if (this.getEditionMode) {
                        this.changeStatusDisabled(true)
                    } else {
                        this.nextPage()
                    }
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.showModal('warning-modal-ref')
                })
                .finally(() => {
                    this.setIsLoading(false)
                })
        },
        loadingFiles(data) {
            this.form.singleFileData = {
                name: data.url_logo.split('.')[0],
                type: data.url_logo.split('.')[1]
            }

            this.form.urlSingleFileData = this.$PPP_URL_FILE + data.url_logo
            this.form.urlFile = data.url_logo
        },
        loadingFilesTemp(data) {
            this.form.singleFileData = {
                name: data.urlLogoTemp.split('blob:')[0],
                type: data.urlLogoTemp.split('blob:')[1]
            }

            this.form.urlSingleFileData = data.urlLogoTemp
            this.form.urlFileTemp = data.urlLogoTemp
            this.firstInfoData.url_logo = data.url_logo
        },
        removeSingleFile() {
            this.imageSelected = false
            this.form.urlSingleFileData = null
            this.form.urlFile = null

            if (this.firstInfoData && this.firstInfoData.urlLogoTemp) {
                this.form.urlFileTemp = null
                this.firstInfoData.url_logo = null
            }
        },
        changeHasCnpj() {
            this.form.cnpj = null
        },
        getSingleFileData() {
            return this.form.singleFileData
        },
        onClickFileField(value) {
            this.imageSelected = value
        },
        validateState(nameField) {
            const { $dirty, $error } = this.$v.form[nameField]
            return $dirty ? !$error : null
        },
        onSubmit(event) {
            this.$v.form.$touch()
            if (this.$v.form.$anyError) {
                return
            }

            if (Object.keys(localStorage).includes('usuario')) {
                this.saveData(this.progress)
            } else {
                // save in localStorage
                this.saveTempData(this.progress)
            }
        },
        showModal(refModalName) {
            this.$refs[refModalName].show()
        },
        hideModal(refModalName) {
            this.$refs[refModalName].hide()
        },
        nextPage() {
            this.$router.push({ name: this.usuario ? 'AboutInitiativeForm1' : 'FirstInformationForm3' })
        },
        changeStatusDisabled(status) {
            this.isDisabled = status
        },
        changeRegisterForm(formName) {
            this.setCurrentFormPlatform(formName)
            this.scrollBehavior()
        },
        scrollBehavior(to, from, savedPosition) {
            const ele = document.getElementById('top-register-painel')
            return window.scrollTo({
                top: ele.offsetTop,
                behavior: 'smooth'
            })
        },
        filterData() {
            if (this.receiveData) {
                this.form.hasCnpj.options = this.form.hasCnpj.options.filter(
                    x => Number(this.form.hasCnpj.selected) === x.value
                )
            }
        }
    },
    computed: {
        getEditionMode() {
            return this.editionMode
        },
        getIsDisabled() {
            return this.isDisabled
        },
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getProgress() {
            return this.$store.state.progress
        },
        getAuthorizationData() {
            return this.authorizationData
        },
        getReceiveData() {
            return this.receiveData
        },
        getAbbleNextPage() {
            return this.abbleNextPage
        }
    },
    updated() {
        if (this.form.hasCnpj.selected === 0) {
            this.changeHasCnpj()
        }
    },
    created() {
        this.isDisabled = this.disabled
        this.receiveData === null ? this.fetch() : this.fetchRead()
        this.filterData()
        this.usuario = JSON.parse(localStorage.getItem('usuario'))
    }
}
</script>



// WEBPACK FOOTER //
// src/components/register-first-information-forms/FirstInformationForm2.vue